import React, { useState } from 'react';
import { Field } from 'formik';
import RadioButton from 'web/components/form-elements/RadioButton';
import DebitCard from '../../Debit-Credit-Card';
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/informationIcon.png";

import { StepFiveContainer, CardTypeSection, SubHeading } from 'web/pages/account/registration/corporate-Registration-Styled'

import styles from '../../corporate.module.scss';
import { useEffect } from 'react';
export default ({ props, setFieldValue, pageLanguageContents }) => {

  const radioTypes = [
    {
      value: 'buyerDebitCard',
      label: pageLanguageContents?.Arrow2_Account[55]?.Buyer_OptionOne,
    },
    {
      value: 'creditCard',
      label: pageLanguageContents?.Arrow2_Account[64]?.Buyer_OptionTwo,
    },
  ];
  const [isRadioChanged, setIsRadioChanged] = useState(false);

  const [tooltipBuyer, setTooltipBuyer] = useState(false);
  const iIconBuyer = (infoTxt) => {
    return <>
      <img
        id="TooltipBuyer"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipBuyer}
        target="TooltipBuyer"
        toggle={() =>
          setTooltipBuyer(!tooltipBuyer)
        }
      >
        {infoTxt}
      </Tooltip>
    </>
  }

  const creditCardFun = () => {
    let stepSelected = ''
    let setCardType = props.values.buyerRadioType
    if (props.values.buyerRadioType === "buyerDebitCard") {
      setCardType = "creditCard"
      stepSelected = "debitCard"
    }
    return <div>
      <div className='text-left mt-4 mb-2'>
        <DebitCard
          cardType="creditCard"
          accountType={setCardType}
          stepSelected={stepSelected}
          props={props}
          setFieldValue={setFieldValue}
          id={1}
          pageLanguageContents={pageLanguageContents}
          paymentFor='buying' />
      </div>
    </div>
  }

  useEffect(() => {
    // This effect will be triggered whenever buyerRadioType changes
    setIsRadioChanged(!isRadioChanged);
  }, [props.values.buyerRadioType]);

  return (
    <StepFiveContainer>
      <CardTypeSection>
        <SubHeading>
          <img src={RightArrow} className="right-arrow" alt="right-arrow" />
          {pageLanguageContents?.Arrow2_Account[54]?.Buyer_Arrow}<span className="star">*</span>
          {iIconBuyer(pageLanguageContents?.Arrow2_Account[104]?.BuyerPayment_Info)}
        </SubHeading>
        <div className='col-12 mb-4'>
          <p style={{ margin: '0px', fontSize: '17px' }}>Please populate a valid payment method. This information will be available during the checkout process when transacting on the site. <b><u>Your payment method will not be charged until a transaction is completed.</u></b></p>
          
        </div>
        <div className="col-12">
          <div className={styles.displayFlex}>
            {radioTypes &&
              radioTypes.map((value, index) => (
                <div key={index} className='radioButtonClass'>
                  <Field
                    component={RadioButton}
                    name="buyerRadioType"
                    className="radio-label"
                    id={value.value}
                    disabled={props.values?.buyerPaymentValidated}
                    defaultValue={radioTypes[0].value}
                    onSelect={(e) => {setIsRadioChanged(!isRadioChanged);}}
                    label={value.label}
                  />
                </div>
              ))}
            <p style={{ margin: '0px 50px 0px 20px', display: 'block', textAlign: 'center' }}><span style={{ color: '#27911B', fontWeight: 'bold' }}>{` ACH setup is available once you are logged in!`}</span></p>
          </div>
        </div>
        {props.values.buyerRadioType !== '' && <>
          <div className="col-12" style={{ overflow: 'hidden' }}>
            {props.values?.buyerPaymentValidated && <div className="freezeDivCredit"></div>}
            {isRadioChanged && creditCardFun()} {/* Render creditCardFun() only when isRadioChanged is true */}
          </div>
        </>}
      </CardTypeSection>
    </StepFiveContainer>
  );
};
